const NAV_BREAKPOINT_CSS_VAR = '--breakpoint-nav';
const NAV_BREAKPOINT_FALLBACK = '64rem';

export function getNavMinWidthMediaQuery() {
  if (typeof window === 'undefined') {
    return `(min-width: ${NAV_BREAKPOINT_FALLBACK})`;
  }

  const navBreakpoint = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(NAV_BREAKPOINT_CSS_VAR)
    .trim();

  return `(min-width: ${navBreakpoint || NAV_BREAKPOINT_FALLBACK})`;
}
